import DepositFixedTermMaturitySettings from "@/models/Products/ProductSettings/DefaultSettings/FixedTermMaturity/DepositFixedTermMaturitySettings";

export default class UpdateDepositFixedTermMaturitySettingsRequest extends DepositFixedTermMaturitySettings {
    updatedAt: Date;

    public constructor(settings: DepositFixedTermMaturitySettings, updatedAt: Date) {
        super();
        this.updatedAt = updatedAt;
        if (settings) {
            this.overridable = settings.overridable;
            this.maturityWindowPeriodType = settings.maturityWindowPeriodType;
            this.maturityWindowPeriodValue = +settings.maturityWindowPeriodValue;
            this.maturityType = settings.maturityType;
            this.maturityAction1Type = settings.maturityAction1Type;
            this.maturityAction1ProductId = settings.maturityAction1ProductId;
            this.maturityAction1ProductIssueId = settings.maturityAction1ProductIssueId;
            this.maturityAction1Amount = settings.maturityAction1Amount;
            this.maturityAction2Type = settings.maturityAction2Type;
        }
    }
}